<template>
  <div class="redeem-instruction">
    <BlAccordionMv class="redeem-instruction__content">
      <template #header>
        <BlTextAv variation="body-14" weight="bold">Cara tukar kode voucher</BlTextAv>
      </template>
      <template #content>
        <div v-for="(instruction, idx) in instructionList" :key="idx">
          <div class="flex gap-2 mb-16">
            <div>
              <BlProductImageAv
                :image-url="instruction.img"
                image-placeholder="https://s2.bukalapak.com/attachment/237412/placeholder.png"
                object-fit="fill"
                class="rounded"
              />
            </div>
            <div class="mt-8">
              <BlTextAv variation="caption-12">
                {{ instruction.text }}
              </BlTextAv>
            </div>
          </div>
        </div>
      </template>
    </BlAccordionMv>
  </div>
</template>

<script>
import {BlAccordionMv, BlProductImageAv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'RedeemInstruction',
  components: {
    BlAccordionMv,
    BlProductImageAv,
  },
  data() {
    return {
      instructionList: [
        {
          img: 'https://s0.bukalapak.com/attachment/551062/prakerja-redeem-voucher-code-hi-1.jpg',
          text: 'Salin kode voucher dari email atau riwayat transaksi Bukalapak untuk penukaran.',
        },
        {
          img: 'https://s3.bukalapak.com/attachment/851062/prakerja-redeem-voucher-code-hi-2.jpg',
          text: 'Daftar atau login pada website lembaga pelatihan sesuai akun Prakerja kamu.',
        },
        {
          img: 'https://s1.bukalapak.com/attachment/161062/prakerja-redeem-voucher-code-hi-3.jpg',
          text: 'Masukkan kode voucher yang sudah disalin.',
        },
        {
          img: 'https://s4.bukalapak.com/attachment/461062/prakerja-redeem-voucher-code-hi-4.jpg',
          text: 'Untuk tukar kode redeem, kamu bisa lihat pada dashboard Prakerja pada bagian detail pelatihan.',
        },
        {
          img: 'https://s2.bukalapak.com/attachment/761062/prakerja-redeem-voucher-code-hi-5.jpg',
          text: 'Jika verifikasi berhasil, maka akan ada notifikasi pada website.',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.redeem-instruction {
  &__content {
    &::v-deep {
      .bl-accordion__item {
        border: 1px solid #ebebeb;
        border-radius: 12px;
      }
    }
  }
}
</style>
